import { render, staticRenderFns } from "./LeadsPage.vue?vue&type=template&id=be49f912&scoped=true&"
import script from "./LeadsPage.vue?vue&type=script&lang=js&"
export * from "./LeadsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be49f912",
  null
  
)

export default component.exports